import { STM_DURATION_BASED_PRODUCTS } from 'core/constants/products'
import innerHTML from 'utils/DOM/innerHTML'

function renderPlansCount(countByProduct) {
  if (countByProduct === undefined) {
    return
  }

  const count = STM_DURATION_BASED_PRODUCTS.reduce(
    (accum, current) => accum + (countByProduct[current] || 0),
    0
  )

  if (count > 0) {
    innerHTML('.js-plans-count', count)
  }
}

export default renderPlansCount
